import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_holidays_bestsellers: FaireCategoryEntity = {
  token: "cat_holidays-bestsellers",
  type: "category",
  name: "Bestsellers",
  level: 2,
  parentToken: "cat_holidays-seasonal",
  href: "/category/holidays-seasonal/bestsellers",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
